import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TitlePortal, useSidebarState } from 'react-admin';
import { Box } from '@mui/material';
import CustomSidebar from './CustomSidebar';
import CustomAppBar from './CustomAppBar';
import CustomMenu from './CustomMenu';

const BASE_TITLE = "Yanfaa AI";

const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const CustomLayout = ({ children }) => {
    const location = useLocation();
    const [open] = useSidebarState(); // Get the sidebar's open state

    useEffect(() => {
        const originalTitle = document.title;
        let pageTitle = BASE_TITLE;

        const pathname = location.pathname;
        const segments = pathname.split('/');
        const firstSegment = segments[1];

        if (firstSegment) {
            const resourceName = capitalizeFirstLetter(firstSegment);
            pageTitle = `${resourceName} - ${BASE_TITLE}`;
        } else {
            pageTitle = BASE_TITLE;
        }

        document.title = pageTitle;
        return () => {};
    }, [location.pathname]);

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <CustomAppBar />
            <CustomSidebar>
                <CustomMenu />
            </CustomSidebar>
            <Box
                sx={{
                    display: 'block',
                    paddingLeft: open ? '240px' : '60px', // Adjust padding based on sidebar width
                    paddingRight: '60px',
                    paddingBottom: '60px',
                    paddingTop: '120px',
                    minHeight: 'calc(100vh - 120px)',
                    boxSizing: 'border-box',
                    transition: 'padding-left 0.3s', // Smooth transition for padding
                    '.RaList-main': {
                        width: '100%',
                        '.RaList-content': {
                            display: 'block',
                            overflowX: 'auto',
                        },
                    },
                }}
            >
                <Box>
                    <TitlePortal sx={{ fontWeight: 500, color: '#1a1c1e', fontSize: '30px', marginBottom: '20px' }} />
                </Box>
                <Box
                    sx={{
                        '.RaList-actions': {
                            background: '#fff',
                            padding: '1rem',
                            '.MuiToolbar-root': {
                                padding: '0',
                            },
                            '.MuiFormControl-root': {
                                margin: '0',
                            },
                            '.MuiButtonBase-root': {
                                backgroundColor: '#02d38d',
                                color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#000000',
                                },
                                '&.MuiIconButton-root': {
                                    backgroundColor: '#1a1c1e',
                                    padding: '8px',
                                    margin: '0',
                                    marginLeft: '4px',
                                },
                            },
                        },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default CustomLayout;
